


import React, { useEffect, useState } from 'react';
import StudentTemplate from '../../component/StudentTemplate';
import Loader from '../../component/Loader';
import { useNavigate } from 'react-router-dom';
import logo from "../../Assets/images/gif/danger.gif";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Api from '../../component/Api';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import { Alert } from 'bootstrap';
import useAuth from '../../component/useAuth';


const StudentBvocCourseSelection = () => {

    const navigate = useNavigate();
    const isAuth = useAuth();
    const { http } = Api();
    if (isAuth === false) {
        navigate("/")
    }

    const [isFirstSubmit, setFirstSubmit] = useState(false);
    const [currentSemester, setCurrentSemester] = useState(false);
    const [activeSemesters, setActiveSemesters] = useState(false);
    const [startdate, setStratdate] = useState(false);
    const [enddate, setEnddate] = useState(false);
    const [optionname, setname] = useState(false);

    const [collegeOptions, setCollegeOptions] = useState([]);
    const [disciplineOptions, setdisciplineOptions] = useState([]);
    const [courseOptions, setcourseOptions] = useState([]);
    const [selectedcollege, setSelectedcollege] = useState(false);
    const [selecteddiscipline, setSelectediscipline] = useState(false);
    const [selectedcourse, setSelectedcourse] = useState(false);
    const [schemeData, setSchemeData] = useState([]);
    const [getSemesterName, setSemesterName] = useState([]);
    const [loading, setloading] = useState(true);
    const [issaved, setissaved] = useState(false);

    const [status, setStatus] = useState(false);

    const [result, setResult] = useState([]);



    const [steps] = useState([1, 2, 3, 4, 5, 6, 7, 8]);
    const [current, setCurrent] = useState({
        "DSC 1": [],
        "DSC 2": [],
        "DSC 3": [],
        MDC: [],
        "AEC 2": [],
        "AEC 1": [],
        "SDC1": [],
        "SDC2": [],
        "SDC3": [],
        "MPC": [],
        "MDC": [],
        "AEC": [],
        "SDC (OJT)": [],
    });

    const [student, setstudent] = useState({
        "DSC 1": [],
        "DSC 2": [],
        "DSC 3": [],
        MDC: [],
        "AEC 2": [],
        "AEC 1": [],
        "SDC1": [],
        "SDC2": [],
        "SDC3": [],
        "MPC": [],
        "MDC": [],
        "AEC": [],
        "SDC (OJT)": [],
    });

    const [course_group_id, setcourse_group_id] = useState(false);
    const [scheme_structure_id, setscheme_structure] = useState(false);
    const [group_name, setgroup_name] = useState(false);
    const [show, setShow] = useState(false);
    const [button_true, set_button_true] = useState({});

    const [slected, setSelected] = useState(false);
    const [slected1, setselected1] = useState(false);
    const [backup, setBckup] = useState(false);


    const [error, seterror] = useState(false);


    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobileView(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    const handleClose = (option) => {

        setCurrent(prevState => {
            if (backup[option]) {
                return {
                    ...prevState,
                    [option]: [...backup[option]]
                };
            }
            return prevState; // Return unchanged state if backup[option] doesn't exist
        });

        set_button_true(prevStates => {
            if (backup[option]) {
                return {
                    ...prevStates,
                    [option]: true
                };
            }
            return prevStates; // Return unchanged state if backup[option] doesn't exist
        });

        setShow(false);

    };

    const handleExploreMoreClick = (optionname, course_group_id, scheme_structure_id) => {

        setcourse_group_id(course_group_id);
        setgroup_name(optionname);
        setscheme_structure(scheme_structure_id);
        setSelectedcourse(false);
        setSelectediscipline(false);
        setSelectedcollege(false);
        setdisciplineOptions(false);
        setcourseOptions(false)

        http.get(`/Student/BvocexploreCollegesForOptions`, {
            params: {
                course_group_id: course_group_id,
                group_name: optionname
            }
        })
            .then(response => {

                setCollegeOptions(response.data);


            }).catch(error => {
                if (error.response.data.status_code === 'ERR9') {
                    toast.error("Invalid token");
                    setTimeout(() => {
                        navigate('/');
                    }, 5000);
                }
                else if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
                    toast.error("Data not found");

                }
                else {

                    // console.error("Error in explore colleges for options:", error);
                    toast.error("Something went wrong: ");
                }
            });


        setname(optionname);
        setShow(true);

        setSelected((prevSelected) => {
            const { [optionname]: removedOption, ...rest } = prevSelected;
            return rest;
        });
        setstudent(prevState => ({
            ...prevState,  // Copy the previous state
            [optionname]: []
        }));



    };

    const handleTab = (step) => {
        setSemesterName(step);
        if (step > activeSemesters) {
            toast.error("This semester not active yet")
        }
        else {
            setCurrentSemester(step);

            setstudent({
                "DSC 1": [],
                "DSC 2": [],
                "DSC 3": [],
                MDC: [],
                "AEC 2": [],
                "AEC 1": [],
                "SDC1": [],
                "SDC2": [],
                "SDC3": [],
                "MPC": [],
                "MDC": [],
                "AEC": [],
                "SDC (OJT)": [],
            });

            setCurrent({
                "DSC 1": [],
                "DSC 2": [],
                "DSC 3": [],
                MDC: [],
                "AEC 2": [],
                "AEC 1": [],
                "SDC1": [],
                "SDC2": [],
                "SDC3": [],
                "MPC": [],
                "MDC": [],
                "AEC": [],
                "SDC (OJT)": [],
            });


            set_button_true({});

            setselected1(false);



        }

    };

    const handleNext = () => {
        if (currentSemester < steps.length) {
            setCurrentSemester(currentSemester + 1);
            setSemesterName(currentSemester + 1);

            setstudent({
                "DSC 1": [],
                "DSC 2": [],
                "DSC 3": [],
                MDC: [],
                "AEC 2": [],
                "AEC 1": [],
                "SDC1": [],
                "SDC2": [],
                "SDC3": [],
                "MPC": [],
                "MDC": [],
                "AEC": [],
                "SDC (OJT)": [],
            });

            setCurrent({
                "DSC 1": [],
                "DSC 2": [],
                "DSC 3": [],
                MDC: [],
                "AEC 2": [],
                "AEC 1": [],
                "SDC1": [],
                "SDC2": [],
                "SDC3": [],
                "MPC": [],
                "MDC": [],
                "AEC": [],
                "SDC (OJT)": [],
            });


            set_button_true({});

            setselected1(false);
        }
    };

    const handlePreviousSemester = () => {
        if (currentSemester > 1) {
            setCurrentSemester(currentSemester - 1);
            setSemesterName(currentSemester - 1);

            setstudent({
                "DSC 1": [],
                "DSC 2": [],
                "DSC 3": [],
                MDC: [],
                "AEC 2": [],
                "AEC 1": [],
                "SDC1": [],
                "SDC2": [],
                "SDC3": [],
                "MPC": [],
                "MDC": [],
                "AEC": [],
                "SDC (OJT)": [],
            });

            setCurrent({
                "DSC 1": [],
                "DSC 2": [],
                "DSC 3": [],
                MDC: [],
                "AEC 2": [],
                "AEC 1": [],
                "SDC1": [],
                "SDC2": [],
                "SDC3": [],
                "MPC": [],
                "MDC": [],
                "AEC": [],
                "SDC (OJT)": [],
            });


            set_button_true({});

            setselected1(false);
        }
    };

    const handlefirstsubmit = () => {
        setFirstSubmit(!isFirstSubmit);
    }

    const handleCancel = () => {
        setFirstSubmit(!isFirstSubmit);
    }

    const cancelForm = () => {
        navigate("/studentbvoccourseselection");
    };



    useEffect(() => {

        http.get(`/Student/getBvocActiveEventsForStudents`, { params: { event_id: 2 } })
            .then(response => {


                if (response.data.http_status === 500) {
                    setCurrentSemester(1);
                }
                else {
                    const activeSemesters = response.data[0].semester_id;
                    setStatus(response.data[0].status);


                    setActiveSemesters(activeSemesters);
                    setSemesterName(activeSemesters);
                    setCurrentSemester(activeSemesters);

                    setEnddate(response.data[0].end_date);
                    setStratdate(response.data[0].start_date);
                }

            }).catch(error => {
                // console.error("Error in get active events:", error);

            });
    }, [])

    useEffect(() => {

        const StudentcourseSelection = () => {

            http.get('Student/getBvocStudentcourseSelection', { params: { semester_id: currentSemester } })
                .then(response => {

                    const newStudentState = {};

                    Object.keys(response.data).forEach((option, optionIndex) => {

                        // Check the conditions for the first option and the current semester

                        if (response.data[option] && response.data[option][0] && response.data[option][0].selected === 1) {
                            setstudent(prevState => ({
                                ...prevState,
                                [option]: [{
                                    college_id: response.data[option][0].college_id,
                                    course_name: response.data[option][0].course_name,
                                    course_id: response.data[option][0].id,
                                    discipline_id: response.data[option][0].discipline_id,
                                    course_group_id: response.data[option][0].course_group_id,
                                    semester: response.data[option][0].semester_name,
                                    scheme_structure_id: response.data[option][0].scheme_structure_id,
                                    college_course_type: response.data[option][0].college_course_type,

                                }]
                            }));

                            setSelected((prevSelected) => ({
                                ...prevSelected,
                                [option]: {
                                    id: response.data[option][0].id,  // Store the id
                                    type: response.data[option][0].college_course_type,  // Store the type (or any other type property from your data)
                                },
                            }));

                            if (response.data[option][0].student_exists === 'true') {

                                setissaved(true);
                            }

                        }
                        else {
                            // Map through the options and check if `selected === 1`
                            const selectedOptions = response.data[option].filter(opt => opt.selected === 1).map(opt => ({
                                college_id: opt.college_id,
                                course_name: opt.course_name,
                                course_id: opt.id,
                                discipline_id: opt.discipline_id,
                                course_group_id: opt.course_group_id,
                                scheme_structure_id: opt.scheme_structure_id,
                                college_course_type: opt.college_course_type

                            }));

                            if (selectedOptions.length > 0) {

                                newStudentState[option] = selectedOptions;

                                setSelected((prevSelected) => ({
                                    ...prevSelected,
                                    [option]: {
                                        id: selectedOptions[0]?.course_id,  // Store the course ID
                                        type: selectedOptions[0]?.college_course_type,  // Store the course type (or any relevant type property)
                                    },
                                }));


                            }
                        }


                    });
                    setstudent(prevState => ({
                        ...prevState,
                        ...newStudentState
                    }));

                    setResult(response.data);


                }).catch(error => {
                    // console.log(error);
                    setloading(false);
                    setResult([]);
                    if (error.response.data.status_code === 'ERR9') {
                        toast.error("Invalid token");
                        setTimeout(() => {
                            navigate('/');
                        }, 5000);
                    }
                    else if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
                        toast.error("Data not found");

                    }
                    else {

                        // console.error("Error in get student course selection:", error);
                        toast.error("Something went wrong: ");
                    }

                });


        }

        if (currentSemester) {

            StudentcourseSelection()
        }


    }, [currentSemester])


    useEffect(() => {
        http.get('Student/getExploreOptions', {
            params: {

                semester: currentSemester

            }
        })
            .then(response => {
                const newExplore = {};

                if (response.data && typeof response.data === 'object') {
                    Object.entries(response.data).forEach(([key, value]) => {
                        newExplore[key] = [{
                            college_id: value.college_id,
                            college_name: value.college_name,
                            discipline_id: value.discipline_id,
                            discipline_name: value.discipline_name,
                            course_id: value.course_id,
                            course_name: value.course_name,
                            course_group_id: value.course_group_id,
                            scheme_structure_id: value.scheme_structure_id,
                            semester_id: value.semester_id,
                            paper_identifier: value.paper_identifier,
                            college_course_type: value.college_course_type,
                        }];

                        set_button_true(prevStates => ({
                            ...prevStates,
                            [key]: true
                        }));


                    });
                } else {
                    // console.log('no data');
                }

                setCurrent(prevState => ({
                    ...prevState,
                    ...newExplore
                }));


                setBckup(newExplore);
                setloading(false);
            })
            .catch(error => {

                setloading(false);
            });

    }, [result]);


    const handleCollegeChange = (selectedOption) => {

        setSelectedcollege(selectedOption);
        setSelectediscipline(false);
        setSelectedcourse(false);
    };

    useEffect(() => {

        if (selectedcollege) {
            http.get(`Student/BvocexploreCollegeDiciplines`, {
                params: {
                    college_id: selectedcollege?.value,
                    course_group_id: course_group_id,
                    group_name: group_name
                }
            })

                .then(response => {
                    setdisciplineOptions(response.data);
                }).catch(error => {
                    if (error.response.data.status_code === 'ERR9') {
                        toast.error("Invalid token");
                        setTimeout(() => {
                            navigate('/');
                        }, 5000);
                    }
                    else if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
                        toast.error("Data not found");

                    }
                    else {

                        // console.error("Error in explore college diciplines:", error);
                        toast.error("Something went wrong: ");
                    }
                })
        }

    }, [selectedcollege])


    const handleDisiplinechange = (selectedOption) => {

        setSelectediscipline({
            value: selectedOption.disciplineId,
            label: selectedOption.label,
            type: selectedOption.type
        });

        setSelectedcourse(false)

    }

    useEffect(() => {

        if (selecteddiscipline && selectedcollege) {


            http.get(`Student/BvocexploreCollegeCourses`, {
                params: {
                    college_id: selectedcollege?.value,
                    semester_id: activeSemesters,
                    admission_year: schemeData[0]?.admissionyear,
                    discipline_id: selecteddiscipline?.value,
                    course_group_id: course_group_id,
                    group_name: group_name,
                    scheme_structure_id: scheme_structure_id,
                    college_course_type: selecteddiscipline?.type,
                }
            })
                .then(response => {
                    const disciplineKey =
                        selecteddiscipline?.label?.split(" - ")[0];
                    setcourseOptions(response.data.processedCourses[disciplineKey] || []);
                    setSelectedcourse(null);
                    setselected1(null);

                }).catch(error => {
                    if (error.response.data.status_code === 'ERR9') {
                        toast.error("Invalid token");
                        setTimeout(() => {
                            navigate('/');
                        }, 5000);
                    }
                    else if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
                        toast.error("Data not found");

                    }
                    else {

                        // console.error("Error in explore college courses:", error);
                        toast.error("Something went wrong: ");
                    }
                })
        }

    }, [selecteddiscipline])

    const handleCoursechange = (selectedOption, option) => {
      
        setSelectedcourse(selectedOption);
        setselected1(selectedOption.value);
    }

    const handlestudentselection = (option, selectedOption) => {

        //AEC1 and AEC2 validation
        if (activeSemesters === 2 && (option === "AEC1" || option === "AEC2")) {

            if (option === "AEC1" && student["AEC2"]?.length > 0) {
                toast.error("Only one AEC is allowed. Clear AEC2 first.");
                return;
            }

            if (option === "AEC2" && student["AEC1"]?.length > 0) {
                toast.error("Only one AEC is allowed. Clear AEC1 first.");
                return;
            }
        }
        const course_id = selectedOption.id;
        const type = selectedOption.type;
        const coursesArray = result[option] || [];

        setSelected((prevSelected) => ({
            ...prevSelected,
            [option]: {
                id: selectedOption.id,
                type: selectedOption.type,
            },
        }));

        if (Array.isArray(coursesArray)) {

            try {
                const course = coursesArray.find(opt => opt.id === parseInt(course_id) && opt.college_course_type === type);

                if (course) {
                    setstudent(prevState => ({
                        ...prevState,
                        [option]: [{
                            college_id: course.college_id,
                            course_name: course.course_name,
                            course_id: course.id,
                            discipline_id: course.discipline_id,
                            course_group_id: course.course_group_id,
                            scheme_structure_id: course.scheme_structure_id,
                            college_course_type: course.college_course_type


                        }]
                    }));

                    setCurrent(prevState => ({
                        ...prevState,
                        [option]: []
                    }));
                }
                else {
                    // console.error('Error during find operation');
                }
            } catch (error) {
                // console.error('Error during find operation:', error);
            }
        }


    }


    const handleSuccess = (option) => {       

        const college = collegeOptions.find(option => parseInt(option.college_id) === parseInt(selectedcollege?.value));
        const disiplin = disciplineOptions.find(option => parseInt(option.discipline_id) === parseInt(selecteddiscipline?.value));
        const cousre = courseOptions.find(option => parseInt(option.id) === parseInt(selectedcourse?.value));

        if (college && disiplin && cousre) {

            setCurrent(prevState => ({
                ...prevState,  // Copy the previous state
                [option]: [{   // Update the specific option
                    college_name: college.college_name,
                    college_id: college.college_id,
                    discipline_id: disiplin.discipline_id,
                    course_id: cousre.id,
                    discipline_name: disiplin.discipline_name,
                    course_name: cousre.course_name,
                    course_group_id: cousre.course_group_id,
                    scheme_structure_id: cousre.scheme_structure_id,
                    college_course_type: cousre.college_course_type,

                }]
            }));




            setstudent(prevState => ({
                ...prevState,  // Copy the previous state
                [option]: []
            }));

            setSelected((prevSelected) => ({
                ...prevSelected,
                [option]: {
                    id: cousre.id,
                    type: cousre.college_course_type,
                },
            }));

            setShow(false);

            set_button_true(prevStates => ({
                ...prevStates,
                [option]: true
            }));

        } else {
            // console.error("Invalid selection for college, discipline, or course.");
        }


    }

    const handleExploreMoreClick_Clear = (option) => {
        setstudent(prev => ({
            ...prev,
            [option]: []
        }));
        setCurrent(prevState => ({
            ...prevState,  // Copy the previous state
            [option]: []
        }));


        set_button_true(prevStates => ({
            ...prevStates,
            [option]: false
        }));

        setselected1(false);
    }



    const handleClearoption = (option) => {

        setSelected((prevSelected) => {
            const { [option]: removedOption, ...rest } = prevSelected;
            return rest;
        });
        setstudent(prevState => ({
            ...prevState,  // Copy the previous state
            [option]: []
        }));
    }

    const handleSubmit = () => {

        let final = {};
        let flag = false

        const hasValue = arr => Array.isArray(arr) && arr.length > 0;

        // AEC CHECK ACROSS BOTH PARTS
        if (activeSemesters === 2) {

            const aec1Selected =
                hasValue(student["AEC1"]) || hasValue(current["AEC1"]);

            const aec2Selected =
                hasValue(student["AEC2"]) || hasValue(current["AEC2"]);

            if (!aec1Selected && !aec2Selected) {
                toast.error("Please select either AEC 1 or AEC 2.");
                return;
            }
        }


        Object.keys(student).forEach(option => {

            if (Array.isArray(student[option]) && student[option].length > 0) {

                final[[option]] = student[option].map(opt => ({

                    college_id: opt.college_id,
                    course_id: opt.course_id,
                    discipline_id: opt.discipline_id,
                    course_group_id: opt.course_group_id,
                    scheme_structure_id: opt.scheme_structure_id,
                    college_course_type: opt.college_course_type

                }));
            } else if (Array.isArray(current[option]) && current[option].length > 0) {

                final[[option]] = current[option].map(opt => ({
                    college_id: opt.college_id,
                    course_id: opt.course_id,
                    discipline_id: opt.discipline_id,
                    course_group_id: opt.course_group_id,
                    scheme_structure_id: opt.scheme_structure_id,
                    college_course_type: opt.college_course_type
                }));
            }
        });

        if (schemeData.some(scheme => scheme.studentcoursestatus === 'Rejected')) {
            const rejectedSchemes = schemeData.filter(scheme => scheme.studentcoursestatus === 'Rejected');
            const rejectedOptions = {};

            rejectedSchemes.forEach(scheme => {
                const option = scheme.paper_identifier;
                rejectedOptions[option] = final[option];
            });

            final = rejectedOptions;
            flag = true;
        }

        if (!error) {

            setloading(true);

            http.post(`Student/BvocAddStudentCourses`, {

                semester_id: activeSemesters,
                data: final

            })
                .then(response => {

                    if (response.data.status_code === "MSG1") {
                        toast.success("Data Stored Successfully");
                        setloading(false);
                        setissaved(!issaved);
                        // setTimeout(() => {
                        //     if (flag) {
                        //         window.location.reload();
                        //     }
                        // }, 3000);
                    }
                }).catch(error => {
                    if (error.response.data.status_code === 'ERR65') {
                        toast.error(error.response.data.message ? error.response.data.message : "All seats are taken. Kindly select another course");
                    }
                    else if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
                        toast.error("Data not found");
                    }
                    else if (error.response.data.status_code === 'ERR1') {
                        toast.error("Validation Failed");
                    }
                    else if (error.response.data.status_code === 'ERR2' || error.response.data.http_status === 500) {
                        toast.error("Error while inserting");
                    }
                    else if (error.response.data.status_code === 'ERR38') {
                        toast.error("Paper count mismatch. Select all fields");
                    }
                    else if (error.response.data.status_code === 'ERR36') {
                        toast.error("Parameter request failed");
                    }
                    else if (error.response.data.status_code === 'ERR5' || error.response.data.http_status === 500) {
                        toast.error("Data not found");
                    }
                    else {
                        // console.error("Error in Submission of courses:", error);
                        toast.error("Something went wrong: ");
                    }

                    setloading(false);
                })
        }
        else {

            toast.error("Select all fields and try again");
        }

    }

    useEffect(() => {
        // Call the API to get the scheme structure
        http.get('/Student/getBvocSchemeStructure')
            .then(response => {
                setSchemeData(response.data); // Save the API response data

            })
            .catch(error => {
                if (error.response?.data?.status_code === 'ERR9') {
                    toast.error("Invalid token");
                    setTimeout(() => {
                        navigate('/');
                    }, 5000);
                } else if (error.response?.data?.http_status === 500 || error.response?.data?.status_code === 'ERR5') {
                    toast.error("Data not found");
                } else {
                    // console.error("Error fetching scheme structure:", error);
                    toast.error("Something went wrong.");
                }
            });
    }, []);

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),
        /* Additional custom scrollbar styling for WebKit-based browsers */
        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };


    return (
        <StudentTemplate>
            <ToastContainer />
            {loading ? (

                <Loader />

                // <div className="container-fluid">
                //     <div className="row justify-content-center align-items-center">
                //         <div className="col-sm-12">
                //             <div className="card h-100">
                //                 <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                //                     <div className="containeranimate">
                //                         <div className="dot"></div>
                //                         <div className="dot"></div>
                //                         <div className="dot"></div>
                //                         <div className="dot"></div>
                //                         <div className="dot"></div>
                //                         <div className="dot"></div>
                //                         <div className="dot"></div>
                //                         <div className="dot"></div>
                //                     </div>
                //                 </div>
                //             </div>
                //         </div>
                //     </div>
                // </div>

            ) : (

                <div className="container-fluid ">
                    <div className="row m-b-50">
                        <div className="col-sm-12" >
                            <div className="card">
                                <div className="card-header">
                                    <div className="py-3 st-hed-pb d-flex justify-content-center align-items-center text-center mobile">
                                        <h4 className='mobile'>Student B.Voc Course Selection</h4>

                                    </div>
                                </div>


                                <div className="d-none d-md-block"> {/* Show only on desktop devices */}

                                    <div className="card p-4" style={{ margin: '0', boxShadow: 'none', borderRadius: '0' }}>
                                        <ul className="progress-steps12">
                                            {steps.map((step, index) => (
                                                <li
                                                    className={`step12 ${index < currentSemester - 1 ? 'completed12' : ''} ${index === currentSemester - 1 ? 'active12' : ''} ${index + 1 > activeSemesters ? 'inactive12' : ''}`}
                                                    key={index}
                                                    onClick={() => {
                                                        if (index + 1 <= activeSemesters) {
                                                            handleTab(index + 1);
                                                        }
                                                    }}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={`Semester ${index + 1}`}
                                                >
                                                    <div className="step-content12">
                                                        <span className="step-circle12">{index + 1}</span>
                                                        <div className="step-info12 mt-2 text-center">
                                                            <h6 className="mb-1">Semester {index + 1}</h6>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                </div>

                                <div className="d-md-none"> {/* Show only on mobile devices */}

                                    <div className="card" style={{ margin: '10px', boxShadow: 'none', borderRadius: '0' }}>
                                        <div className="accordion" id="semesterAccordion">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header mobile" id="semesterHeading">
                                                    <button
                                                        className="accordion-button m-0 p-0 "
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#semesterCollapse"
                                                        aria-expanded="true"
                                                        aria-controls="semesterCollapse"

                                                    >
                                                        <li
                                                            className="step12 active12 mobile"
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            style={{ listStyle: 'none' }}
                                                        >
                                                            <div className="step-content12">
                                                                <span className="step-circle12">{currentSemester}</span>
                                                                <div className="step-info12 mt-2 text-center">
                                                                    <i className="fas fa-chevron-down"></i>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </button>
                                                </h2>

                                                <div
                                                    id="semesterCollapse"
                                                    className="accordion-collapse collapse"
                                                    aria-labelledby="semesterHeading"
                                                    data-bs-parent="#semesterAccordion"
                                                >
                                                    <div className="accordion-body">
                                                        <hr width="100%" color="black" style={{ height: "1px" }} className='p-0 mb-3 mt-0'></hr>
                                                        <ul className="progress-steps">
                                                            {steps.map((step, index) => (
                                                                <li
                                                                    className={`step ${index < currentSemester - 1 ? 'completed' : ''} ${index === currentSemester - 1 ? 'active' : ''} ${index + 1 > activeSemesters ? 'inactive' : ''}`}
                                                                    key={index}
                                                                    onClick={() => {
                                                                        if (index + 1 <= activeSemesters) {
                                                                            handleTab(index + 1);
                                                                            document.getElementById('semesterCollapse').classList.remove('show');
                                                                        }
                                                                    }}
                                                                    data-bs-toggle="tooltip"
                                                                    data-bs-placement="top"
                                                                    title={`Semester ${index + 1}`}
                                                                >
                                                                    <div className="step-content">
                                                                        <span className="step-circle">{index + 1}</span>
                                                                        <div className="step-info mt-2 text-center mobile">
                                                                            <h6 className="mb-1 mobile">Semester {index + 1}</h6>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>





                                <div className={`card-body pdg ${show ? 'blur-background' : ''}`}>
                                    <div className="table-responsive">

                                        <div className="container-fluid">
                                            {steps.map((step, index) => {
                                                const isActiveStep = activeSemesters === index + 1;
                                                const currentDate = new Date();
                                                const startDate = new Date(startdate);
                                                const endDate = new Date(enddate);
                                                const isWithinDateRange = currentDate >= startDate && currentDate <= endDate;
                                                const isSelectable = isActiveStep && isWithinDateRange && status === 'active' && !issaved;
                                                const semesterName = student?.['DSC 1'][0]?.semester;

                                                return (
                                                    <div key={index} className={`card mb-4 ${currentSemester === index + 1 ? 'd-block' : 'd-none'}`}>
                                                        <div className="card-header bg-primary text-white">
                                                            <h5 className="mb-0 mobile1">{getSemesterName ? `Semester- ${getSemesterName}` : ''}</h5>
                                                        </div>
                                                        <div className="txt-aln mobile1"><p> Note: <span className="text-danger">*</span >To select courses from other colleges click "Explore More -(<i className="bi bi-search"></i>)"</p></div>
                                                        <div className="card-body">
                                                            {Object.keys(result).map((option, optionIndex) => {

                                                                const courseDataArray = result[option] || []; // first element of the option array
                                                                const courseOptionName = option; // first element of the option array


                                                                const isSingle = courseDataArray.length === 1 && courseDataArray[0]?.single_data === 1;
                                                                const isAEC = option === "AEC1" || option === "AEC2";
                                                                const isSemester2 = activeSemesters === 2;

                                                                // Check if AEC1 / AEC2 already selected
                                                                const aec1Selected = student["AEC1"] && student["AEC1"].length > 0;
                                                                const aec2Selected = student["AEC2"] && student["AEC2"].length > 0;

                                                                let aec1ExSelected = false;
                                                                let aec2ExSelected = false;

                                                                if (option === "AEC2") {


                                                                    if (current["AEC1"] && current["AEC1"].length > 0) {

                                                                        aec2ExSelected = true;
                                                                    }
                                                                }
                                                                else if (option === "AEC1") {

                                                                    if (current["AEC2"] && current["AEC2"].length > 0) {

                                                                        aec1ExSelected = true;
                                                                    }
                                                                }




                                                                // Disable logic
                                                                const disableAECSelect =
                                                                    isSemester2 &&
                                                                    isAEC &&
                                                                    (
                                                                        (option === "AEC1" && aec2Selected) ||
                                                                        (option === "AEC2" && aec1Selected) ||
                                                                        (aec1ExSelected) ||
                                                                        (aec2ExSelected)
                                                                    );

                                                                return (
                                                                    <div key={optionIndex} className="mb-3">
                                                                        <label className="form-label">
                                                                            {
                                                                                (schemeData[0].discipline_id === 81 || schemeData[0].discipline_id === 79) && option === "Minor" && currentSemester > 2
                                                                                    ? "Major 3"
                                                                                    : (schemeData[0].discipline_id === 80 || schemeData[0].discipline_id === 58) && option === "Minor" && currentSemester > 2
                                                                                        ? "Major Elective"
                                                                                        : option
                                                                            }

                                                                            {/* {optionIndex === 0 && (<span className="text-danger"> &nbsp;*</span>
                                                                        )} */}
                                                                        </label>
                                                                        {(!courseDataArray || courseDataArray.length === 0) ? (
                                                                            // Show as textbox if single_data === 1 with Explore More
                                                                            <div>
                                                                                <div className="d-flex">
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={courseDataArray[0]?.course_name || 'N/A'}
                                                                                        readOnly
                                                                                        style={{ width: "none" }}
                                                                                    />

                                                                                    {/* Explore More Button */}

                                                                                    {["MPC", "MDC", "AEC"].includes(courseOptionName) && (
                                                                                        <div>
                                                                                            {button_true[option] === true ? (
                                                                                                // --- CLEAR BUTTON ---
                                                                                                <button
                                                                                                    className="btn btn-primary ms-2 course-explore-btn"
                                                                                                    onClick={() => handleExploreMoreClick_Clear(option)}
                                                                                                    disabled={
                                                                                                        issaved ||
                                                                                                        (
                                                                                                            schemeData.find(scheme => scheme.paper_identifier === option)?.studentcoursestatus !== 'Rejected' &&
                                                                                                            isSelectable === false
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    {isMobileView ? (
                                                                                                        <i className="bi bi-x"></i>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            Clear <i className="bi bi-x-lg"></i>
                                                                                                        </>
                                                                                                    )}
                                                                                                </button>
                                                                                            ) : (
                                                                                                // --- EXPLORE MORE + CLOSE BUTTONS ---
                                                                                                <div className="d-flex">
                                                                                                    <button
                                                                                                        className={`btn btn-primary ms-2 course-explore-btn ${result[option][0]?.has_explore_more === 0 ? 'd-none' : ''
                                                                                                            }`}
                                                                                                        disabled={
                                                                                                            issaved ||
                                                                                                            (
                                                                                                                schemeData.find(scheme => scheme.paper_identifier === option)?.studentcoursestatus !== 'Rejected' &&
                                                                                                                isSelectable === false
                                                                                                            )
                                                                                                        }
                                                                                                        onClick={() => {
                                                                                                            const matchingScheme = schemeData.find(
                                                                                                                scheme => scheme.paper_identifier === option
                                                                                                            );
                                                                                                            const courseGroupId = matchingScheme?.course_group_id;
                                                                                                            const Scheme = matchingScheme?.id;
                                                                                                            handleExploreMoreClick(option, courseGroupId, Scheme);
                                                                                                        }}
                                                                                                    >
                                                                                                        {isMobileView ? (
                                                                                                            <i className="bi bi-search"></i>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                Explore More <i className="bi bi-arrow-right m-l-10"></i>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </button>

                                                                                                    <button
                                                                                                        className={`ms-2 custom-close-btn course-explore-btn ${result[option][0]?.has_explore_more === 0 ||
                                                                                                            !Object.keys(slected).includes(option)
                                                                                                            ? 'd-none'
                                                                                                            : ''
                                                                                                            }`}
                                                                                                        onClick={() => handleClearoption(option)}
                                                                                                        disabled={
                                                                                                            issaved ||
                                                                                                            (
                                                                                                                schemeData.find(scheme => scheme.paper_identifier === option)?.studentcoursestatus !== 'Rejected' &&
                                                                                                                isSelectable === false
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        {isMobileView ? (
                                                                                                            <span className="close-icon">×</span>
                                                                                                        ) : (
                                                                                                            <span className="close-icon">×</span>
                                                                                                        )}
                                                                                                    </button>
                                                                                                </div>
                                                                                            )}
                                                                                        </div>

                                                                                    )}



                                                                                </div>

                                                                                {Array.isArray(current[option]) && current[option].length > 0 && (
                                                                                    //console.log("current[option]==", current[option]),
                                                                                    <div className="d-flex w-100 mt-3 mx-3 gap-3">
                                                                                        <div className="flex-grow-1 text-center">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control text-center"
                                                                                                value={current[option][0]?.college_name || 'No College Name'}
                                                                                                disabled
                                                                                            />
                                                                                        </div>
                                                                                        <div className="flex-grow-1 text-center">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control text-center"
                                                                                                value={current[option][0]?.discipline_name || 'No Discipline Name'}
                                                                                                disabled
                                                                                            />
                                                                                        </div>
                                                                                        <div className="flex-grow-1 text-center">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control text-center"
                                                                                                value={current[option][0]?.course_name || 'No Course Name'}
                                                                                                disabled
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                        ) : isSingle ? (
                                                                            // Show as textbox if single_data === 1
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                value={courseDataArray[0]?.course_name || 'N/A'}
                                                                                readOnly
                                                                            />
                                                                        ) : (
                                                                            // Otherwise show as select dropdown
                                                                            <>
                                                                                <div className="d-flex">
                                                                                    <Select
                                                                                        styles={customStyles}
                                                                                        maxMenuHeight={200}

                                                                                        className="flex-grow-1"
                                                                                        options={
                                                                                            Array.isArray(courseDataArray)
                                                                                                ? courseDataArray
                                                                                                    .filter(opt => {
                                                                                                        const isSelected = Object.values(slected).some(selectedItem => selectedItem.id === opt.id);
                                                                                                        return !isSelected || Object.keys(slected).some(key => key === option && slected[key].id === opt.id);
                                                                                                    })
                                                                                                    .map(opt => ({
                                                                                                        value: opt.course_name,
                                                                                                        label: opt.course_name,
                                                                                                        type: opt.college_course_type,
                                                                                                        id: opt.id,
                                                                                                    }))
                                                                                                : []
                                                                                        }
                                                                                        placeholder="Select a course..."
                                                                                        isSearchable={true}
                                                                                        required
                                                                                        isDisabled={
                                                                                            disableAECSelect ||   // AEC rule
                                                                                            issaved ||
                                                                                            (
                                                                                                schemeData.find(scheme => scheme.paper_identifier === option)?.studentcoursestatus !== 'Rejected'
                                                                                                &&
                                                                                                (current[option] && current[option].length > 0 || isSelectable === false)
                                                                                            )
                                                                                        }
                                                                                        onChange={(selectedOption) => handlestudentselection(option, selectedOption)}
                                                                                        value={student[option]?.length > 0 ? { value: student[option][0].course_id, label: student[option][0].course_name } : null}

                                                                                    />

                                                                                    {button_true[option] && button_true[option] === true ? (
                                                                                        <button
                                                                                            className="btn btn-primary ms-2"
                                                                                            onClick={() => handleExploreMoreClick_Clear(option)}
                                                                                            disabled={
                                                                                                issaved ||
                                                                                                (
                                                                                                    schemeData.find(scheme => scheme.paper_identifier === option)?.studentcoursestatus !== 'Rejected'
                                                                                                    &&
                                                                                                    (isSelectable === false)
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            {isMobileView ? (
                                                                                                <i class="bi bi-x"></i>
                                                                                            ) : (
                                                                                                <>
                                                                                                    Clear <i class="bi bi-x-lg"></i>
                                                                                                </>
                                                                                            )}
                                                                                        </button>

                                                                                    ) : (

                                                                                        <div className="d-flex">

                                                                                            <button
                                                                                                className={`btn btn-primary ms-2 ${result[option][0]?.has_explore_more === 0 ? 'd-none' : ''}`}

                                                                                                disabled={
                                                                                                    disableAECSelect ||
                                                                                                    issaved ||
                                                                                                    (
                                                                                                        schemeData.find(scheme => scheme.paper_identifier === option)?.studentcoursestatus !== 'Rejected'
                                                                                                        &&
                                                                                                        (isSelectable === false)
                                                                                                    )
                                                                                                }


                                                                                                onClick={() => {

                                                                                                    const matchingScheme = schemeData.find(scheme => scheme.paper_identifier === option);

                                                                                                    const courseGroupId = matchingScheme?.course_group_id;
                                                                                                    const Scheme = matchingScheme?.id;

                                                                                                    handleExploreMoreClick(option, courseGroupId, Scheme);
                                                                                                }}
                                                                                            >
                                                                                                {isMobileView ? (
                                                                                                    <i className="bi bi-search"></i>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        Explore More <i className="bi bi-arrow-right m-l-10 "></i>
                                                                                                    </>
                                                                                                )}
                                                                                            </button>

                                                                                            <button
                                                                                                className={`ms-2 custom-close-btn ${result[option][0]?.has_explore_more === 0 ||
                                                                                                    !Object.keys(slected).some(key => key === option) ?
                                                                                                    'd-none' : ''
                                                                                                    }`}
                                                                                                onClick={() => handleClearoption(option)}
                                                                                                disabled={
                                                                                                    issaved ||
                                                                                                    (
                                                                                                        schemeData.find(scheme => scheme.paper_identifier === option)?.studentcoursestatus !== 'Rejected'
                                                                                                        &&
                                                                                                        (isSelectable === false)
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                {isMobileView ? (
                                                                                                    <span class="close-icon">×</span>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <span class="close-icon">×</span>
                                                                                                    </>
                                                                                                )}
                                                                                            </button>

                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                                <div className="d-flex">
                                                                                    {Array.isArray(current[option]) && current[option].length > 0 && (
                                                                                        <div className="d-flex w-100 mt-3 mx-3 gap-3">
                                                                                            <div className="flex-grow-1 text-center">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control text-center"
                                                                                                    value={current[option][0]?.college_name || 'No College Name'}
                                                                                                    disabled
                                                                                                />
                                                                                            </div>
                                                                                            <div className="flex-grow-1 text-center">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control text-center"
                                                                                                    value={current[option][0]?.discipline_name || 'No Discipline Name'}
                                                                                                    disabled
                                                                                                />
                                                                                            </div>
                                                                                            <div className="flex-grow-1 text-center">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control text-center"
                                                                                                    value={current[option][0]?.course_name || 'No Course Name'}
                                                                                                    disabled
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                </div>


                                                                            </>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>


                                                        <div className="card-footer d-flex justify-content-center text-center">

                                                            <button
                                                                className="btn btn-outline-secondary me-3 "
                                                                onClick={handlePreviousSemester}
                                                                disabled={currentSemester === 1}
                                                            >
                                                                Back
                                                            </button>
                                                            {(() => {
                                                                const hasRejectedScheme = schemeData.some(scheme => scheme.studentcoursestatus === 'Rejected');

                                                                if (currentSemester === activeSemesters) {
                                                                    if (!issaved && (isSelectable || hasRejectedScheme)) {
                                                                        return (
                                                                            <button className="btn btn-primary" onClick={handleSubmit}>
                                                                                Save
                                                                            </button>
                                                                        );
                                                                    } else if (!isSelectable && issaved) {
                                                                        return (
                                                                            <button className="btn btn-outline-secondary ms-3" onClick={() => setissaved(false)}>
                                                                                Edit
                                                                            </button>
                                                                        );
                                                                    } else if (!isSelectable) {
                                                                        return (
                                                                            <button className="btn btn-outline-secondary ms-3" disabled={true}>
                                                                                Next
                                                                            </button>
                                                                        );
                                                                    }
                                                                }

                                                                return (
                                                                    <button
                                                                        className="btn btn-outline-secondary ms-3"
                                                                        onClick={handleNext}
                                                                        disabled={currentSemester === steps.length}
                                                                    >
                                                                        Next
                                                                    </button>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>


                                        {/* //EXPLORE MORE MODAL */}


                                        {/* //END OF EXPLORE MORE MODAL */}

                                        {/* //CONFIRM  MODAL */}
                                        <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                                            <div className="modal-dialog modal-dialog-centered" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-body">
                                                        <div className="modal-toggle-wrapper">
                                                            <ul className="modal-img">
                                                                <li> <img src={logo} /></li>
                                                            </ul>
                                                            <h4 className="text-center pb-2">Warning  Irreversible Action?</h4>
                                                            <p className="text-center">You are about to submit your changes.Once submitted,this action cannot be undone.</p>
                                                            <p className="text-center">Are you sure you want to proceed?</p>
                                                            <div className="d-flex justify-content-center mt-3">
                                                                <button className="btn btn-danger mx-2" onClick={() => handleSuccess()}>Submit</button>
                                                                <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* //END OF CONFIRM  MODAL */}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-labelledby="fullScreenModalLabel" aria-hidden={!show}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="fullScreenModalLabel">Explore More : {
                                (schemeData[0]?.discipline_id === 81 || schemeData[0]?.discipline_id === 79) && optionname === "Minor" && currentSemester > 2
                                    ? "Major 3"
                                    : (schemeData[0]?.discipline_id === 80 || schemeData[0]?.discipline_id === 58) && optionname === "Minor" && currentSemester > 2
                                        ? "Major Elective"
                                        : optionname
                            }
                            </h5><br />

                            <button type="button" className="btn-close py-0" aria-label="Close" onClick={() => handleClose(optionname)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row mb-3">
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">College</label>
                                        <Select
                                            styles={customStyles}
                                            maxMenuHeight={200}
                                            options={Array.isArray(collegeOptions) ? collegeOptions.map(opt => ({
                                                value: opt.college_id,
                                                label: opt.college_name,
                                                'data-course-group-id': opt.course_group_id
                                            })) : []}
                                            placeholder="Select College"
                                            isSearchable={true}
                                            name="college"
                                            className="react-select"
                                            classNamePrefix="select"
                                            onChange={handleCollegeChange}
                                            value={selectedcollege}


                                        />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Discipline</label>
                                        <Select
                                            styles={customStyles}
                                            maxMenuHeight={200}
                                            options={Array.isArray(disciplineOptions) ? disciplineOptions.map(colopt => ({
                                                value: `${colopt.discipline_id}-${colopt.college_course_type}`,
                                                label: colopt.discipline_name,
                                                type: colopt.college_course_type,
                                                disciplineId: colopt.discipline_id
                                            })) : []}
                                            placeholder="Select Discipline"
                                            isSearchable={true}
                                            name="discipline"
                                            className="react-select"
                                            classNamePrefix="select"
                                            onChange={handleDisiplinechange}
                                            value={selecteddiscipline}
                                        />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Course</label>
                                        <Select
                                            styles={customStyles}
                                            maxMenuHeight={200}



                                            options={
                                                Array.isArray(courseOptions)
                                                    ? courseOptions
                                                        .filter(({ id }) =>
                                                            slected1 !== id &&
                                                            !Object.values(slected).some(selectedItem =>
                                                                selectedItem.id === id
                                                                //selectedItem => selectedItem?.value === id
                                                            )
                                                        )
                                                        .map(({ id, course_name, college_course_type }) => ({
                                                            value: id,
                                                            label: course_name,
                                                            type: college_course_type

                                                        }))
                                                    : []
                                            }


                                            placeholder="Select Course"
                                            isSearchable={true}
                                            name="course"
                                            className="react-select"
                                            classNamePrefix="select"
                                            onChange={(selectedOption) => handleCoursechange(selectedOption, optionname)}
                                            value={selectedcourse}
                                        />
                                    </div>
                                </div>

                                {/* You can add more content here for the full-screen modal */}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary" onClick={() => handleSuccess(optionname)}>Submit</button>
                            <button className="btn btn-secondary" onClick={() => handleClose(optionname)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>


        </StudentTemplate >
    );
};

export default StudentBvocCourseSelection;